import { Typography } from "mobily-ui-library/lib";
import { useContext, useState } from "react";
import { GlobalContext } from "../../context/GlobalContext";
import Copy from '../../assets/Copy.svg';
import User from '../../assets/User.svg';
import Address from '../../assets/Address.svg';
import CircleToggle from '../../assets/CircleToggle.svg';
import { Tooltip } from "antd";

import "./OrderDetails.scss";
import { useTranslation } from "react-i18next";
import { changeDateFormat } from "../../utils";

interface Props {
    status?: string;
}

const OrderDetails = ({ status = '' }: Props) => {
    const { t } = useTranslation();
    const { state }: any = useContext(GlobalContext);
    const { rtl, page, requestDetails } = state;
    const { MobilyOrderNumber, FirstName, FamilyName, BirthDate, NationalId, MobileNumber, EmailAddress, ShortNationalAddress, Region, City, District, Street, BuildingNumber, ZIPcode, PayType } = requestDetails;

    const [orderToggle, setOrderToggle] = useState(false)
    const [copied, setCopied] = useState(false);
    const [copiedTitle, setCopiedTitle] = useState(false);

    const handleCopyMobilyOrderNumber = () => {
        try {
            navigator.clipboard.writeText(MobilyOrderNumber)
            setCopied(true);
            setCopiedTitle(true);
            setTimeout(() => setCopied(false), 1000);
            setTimeout(() => setCopiedTitle(false), 1500)
        } catch (err) {
        }
    }

    const handleOrderToggle = () => {
        setOrderToggle(prevState => {
            (document.querySelector(".order-toggle") as unknown as HTMLElement).style.rotate = !prevState ? '180deg' : "0deg";
            return !prevState
        });
    }

    return (
        <section className='DCS__OrderSection'>
            <div className='DCS__OrderInfo'>
                <div className='DCS__OrderNumber'>
                    <Typography rtl={rtl} className='order-title'>{t('Request_number')}</Typography>
                    <Typography rtl={rtl} className='order-value'>
                        <span>{MobilyOrderNumber}</span>
                    </Typography>
                </div>
                <div className="DCS__OrderCopy">
                    <Tooltip
                        title={copiedTitle ? "Copied!" : undefined}
                        open={copied ? true : false}
                        color="#1890ff"
                        overlayInnerStyle={{ backgroundColor: "#1890ff", color: "#fff", padding: "6px 12px" }} // Tooltip text styles
                    >
                        <img onClick={handleCopyMobilyOrderNumber} src={Copy} alt='Copy' />
                    </Tooltip>
                </div>
            </div>

            {page !== 'successPage' && (
                <>
                    <div className="DCS__OrderDates">
                        <Typography rtl={rtl} className='order-title'>{t('Requested')}</Typography>
                        <Typography rtl={rtl} className='order-value'>{changeDateFormat(requestDetails?.RequestDate)}</Typography>
                    </div>
                    {/* {(status === 'in-progress' || status === 'completed') && (
                        <div className="DCS__OrderDates">
                            <Typography rtl={rtl} className='order-title'>{t('Paid')}</Typography>
                            <Typography rtl={rtl} className='order-value'>{changeDateFormat(requestDetails?.PaymentDate)}</Typography>
                        </div>
                    )} */}
                    {(status === 'completed') && (
                        <div className="DCS__OrderDates">
                            <Typography rtl={rtl} className='order-title'>{t('Completed_on')}</Typography>
                            <Typography rtl={rtl} className='order-value'>{changeDateFormat(requestDetails?.CompletionDate)}</Typography>
                        </div>
                    )}
                </>
            )}

            <div className='line'></div>

            <div className='DCS__OrderDetail'>
                <div className='DCS__OD-title' onClick={handleOrderToggle}>
                    <Typography className='order-tile' rtl={rtl}>{t('Order_details')}</Typography>
                    <img className='order-toggle' src={CircleToggle} alt='toggle' />
                </div>

                {orderToggle && (
                    <div className='DCS__OD-detail'>
                        <div className='OD__CustomerDetail'>
                            <Typography className='OD--title' rtl={rtl}>
                                <img src={User} alt='user' />
                                <span>{t('Customer')}</span>
                            </Typography>

                            <div className='OD--Information'>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t('Name')}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{`${FirstName} ${FamilyName}`}</Typography>
                                </div>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t("ID_number")}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{NationalId}</Typography>
                                </div>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t('DOB')}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{BirthDate}</Typography>
                                </div>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t("Contact_number")}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{MobileNumber}</Typography>
                                </div>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t("Email_address")}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{EmailAddress}</Typography>
                                </div>
                            </div>
                        </div>

                        <div className='OD__AddressDetail'>
                            <Typography className='OD--title' rtl={rtl}>
                                <img src={Address} alt='address' />
                                <span>{t("Address")}</span>
                            </Typography>

                            <div className='OD--Information'>
                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t('Short_National_Address')}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{ShortNationalAddress}</Typography>
                                </div>

                                <div className='ODI'>
                                    <Typography className='ODI-title' rtl={rtl}>{t('Address_details')}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{`${Region}, ${City}, ${District}, ${Street}, ${BuildingNumber}, ${ZIPcode}`}</Typography>
                                </div>
                                {/* <div className='ODI mt-4'>
                                    <Typography className='ODI-title' rtl={rtl}>{t('Payment_Type')}</Typography>
                                    <Typography className='ODI-subtitle' rtl={rtl}>{t(PayType)}</Typography>
                                </div> */}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    )
}

export default OrderDetails;